module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.message) ? _c('div', {
    staticClass: "alert alert-dismissible",
    class: _vm.alertType,
    attrs: {
      "role": "alert"
    }
  }, [_vm._m(0), _vm._v(" "), _c('strong', [_vm._v("Warning!")]), _vm._v(" " + _vm._s(_vm.message) + "\r\n")]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e25590ec!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SharedComponents/Alert.vue
// module id = 661
// module chunks = 2